import { Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { OrderManagementFrame, paymentTypeEnum, statusPaymentEnum } from 'src/app/intefaces/orderManagementFrame';
import { OrderManagementService } from 'src/app/services/orderManagement.service';
import { Order } from 'src/app/intefaces/order';
import { DownloadService } from 'src/app/services/download.service';
import { HttpAlertService } from 'src/app/services/http-alert.service';

@Component({
  selector: 'app-orders-management',
  templateUrl: './orders-management.component.html',
  styleUrls: ['./orders-management.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class OrdersManagementComponent implements OnInit {

  @Input() userId = null;

  public orderFrame: OrderManagementFrame = null;
  public orders: Order[];
  public isDataReady: boolean = false;
  public payStatuses;
  public createdDocumentStatuses;
  public orderStatuses;
  public statusPaymentEnum = statusPaymentEnum;
  public paymentTypeStatuses;
  public paymentTypeEnum = paymentTypeEnum;
  public totalPrice: Number = 0;
  public totalOrders: Number = 0;
  public limit: Number = 0;
  public paginateLoader: boolean = false;
  public showFilters: boolean = false;
  public showEditPanel: boolean = false;
  public selectedEditOrder: Order = null;
  public selectedEditOrder_order: Order;
  public savingInvoice: boolean = false;
  public uploadingManualInvoice: boolean = false;
  public deletingManualInvoice: boolean = false;
  public totalPrice2 = 0;
  public totalPrice3 = 0;

  constructor(
    private orderManagementService: OrderManagementService,
    private download: DownloadService,
    private alertService: HttpAlertService
  ) { }

  ngOnInit(): void {
    this.initData();
    this.getOrder();

    this.payStatuses = [
      { label: 'Wszystkie', value: null },
      { label: 'Zapłacone', value: true },
      { label: 'Oczekuje na wpłatę', value: false }
    ];

    this.createdDocumentStatuses = [
      { label: 'Wszystkie', value: null },
      { label: 'Utworzono dokument', value: true },
      { label: 'Brak dokumentu', value: false },
    ];

    this.orderStatuses = [
      { label: 'Wszystkie', value: null },
      { label: 'Zrealizowane', value: statusPaymentEnum.DONE },
      { label: 'Anulowane', value: statusPaymentEnum.CANCELLED },
    ];

    this.paymentTypeStatuses = [
      { label: 'Wszystkie', value: null },
      { label: 'Przelew zwykły', value: paymentTypeEnum.NORMAL },
      { label: 'Payu', value: paymentTypeEnum.PAYU },
      { label: 'PayPal', value: paymentTypeEnum.PAYYPAL },
      { label: 'Z doładowań', value: paymentTypeEnum.PREPAID },
    ];
  }

  public filterProperty(s: Array<any>) {
    return s.filter(d => d.value != null);
  }

  public onToggleFilter() {
    this.showFilters = !this.showFilters;
  }

  public onFilter() {
    this.getOrder();
  }

  public onEditOrder(order) {
    this.editData(order);
  }

  private initData() {
    this.orderFrame = {
      isPaid: null,
      offset: 0
    };

    if (this.userId) {
      this.orderFrame.userId = this.userId;
    }
  }

  public onDownloadInvoice(order) {
    this.download.downloadInvoiceAdmin(order.invoice).subscribe(data => {
      saveAs(data, 'invoice-order-' + order.id + '.pdf');
      order.invoice.is_downloaded_by_admin = true;
    });
  }

  public onDownloadManualInvoice(order) {
    if (!order?.manual_invoice) {
      return;
    }

    this.download.downloadManualInvoiceAdmin(order.manual_invoice).subscribe(data => {
      saveAs(data, order.manual_invoice.original_name);
    });
  }

  public onSaveEditedInvoice() {
    this.savingInvoice = true;
    this.orderManagementService.editInvoice(this.selectedEditOrder).subscribe(() => {
      this.savingInvoice = false;
      this.showEditPanel = false;
    }, () => {
      this.savingInvoice = false;
    });
  }

  public onOpenManualInvoicePicker(input: HTMLInputElement) {
    input.value = '';
    input.click();
  }

  public onManualInvoiceChange(event) {
    const files: FileList = event.target.files;

    if (!files || files.length === 0 || !this.selectedEditOrder?.id) {
      return;
    }

    this.uploadingManualInvoice = true;
    this.readFileAsDataUrl(files[0]).then((base64Content: string) => {
      this.orderManagementService.uploadManualInvoice({
        order_id: this.selectedEditOrder.id,
        invoice_name: files[0].name,
        invoice_mime_type: files[0].type || 'application/octet-stream',
        invoice_content: base64Content,
      }).subscribe((response: any) => {
        const manualInvoice = response.data.manual_invoice;
        this.selectedEditOrder.manual_invoice = manualInvoice;
        this.selectedEditOrder_order.manual_invoice = manualInvoice;
        this.uploadingManualInvoice = false;
        this.alertService.success('Dodano plik faktury.');
      }, () => {
        this.uploadingManualInvoice = false;
        this.alertService.error('Nie udało się dodać pliku faktury.');
      });
    }).catch(() => {
      this.uploadingManualInvoice = false;
      this.alertService.error('Nie udało się odczytać pliku faktury.');
    });
  }

  public onDeleteManualInvoice() {
    if (!this.selectedEditOrder?.id || !this.selectedEditOrder?.manual_invoice) {
      return;
    }

    if (!window.confirm('Usunąć dodany plik faktury?')) {
      return;
    }

    this.deletingManualInvoice = true;
    this.orderManagementService.deleteManualInvoice(this.selectedEditOrder.id).subscribe(() => {
      this.selectedEditOrder.manual_invoice = null;
      this.selectedEditOrder_order.manual_invoice = null;
      this.deletingManualInvoice = false;
      this.alertService.success('Usunięto plik faktury.');
    }, () => {
      this.deletingManualInvoice = false;
      this.alertService.error('Nie udało się usunąć pliku faktury.');
    });
  }

  public editData(order) {
    this.selectedEditOrder_order = order;
    this.selectedEditOrder = { ...order };
    this.showEditPanel = true;
  }

  public onSaveEditedOrder() {
    this.saveEditOrder(this.selectedEditOrder);
  }

  public saveEditOrder(order: Order) {
    this.orderManagementService.editOrder(order).subscribe(data => {
      const editedOrder: Order = data.data;
      this.selectedEditOrder_order.description_admin = editedOrder.description_admin;
      this.selectedEditOrder_order.is_created_document = editedOrder.is_created_document;
      this.selectedEditOrder_order.status = editedOrder.status;
      this.selectedEditOrder_order.is_paid = editedOrder.is_paid;
      this.showEditPanel = false;
    });
  }

  public paginate(ev) {
    this.orderFrame.offset = ev.page;
    this.paginateLoader = true;
    this.getOrder();
  }

  private fixDate() {
    if (this.orderFrame.dateFrom) {
      const dateFrom: Date = this.orderFrame.dateFrom;
      this.orderFrame.dateFrom = new Date(Date.UTC(dateFrom.getFullYear(), dateFrom.getMonth(), dateFrom.getDate()));
    }

    if (this.orderFrame.dateTo) {
      const dateTo: Date = this.orderFrame.dateTo;
      this.orderFrame.dateTo = new Date(Date.UTC(dateTo.getFullYear(), dateTo.getMonth(), dateTo.getDate()));
    }
  }

  private getOrder() {
    this.fixDate();

    this.orderManagementService.getOrders(this.orderFrame).subscribe(data => {
      this.isDataReady = true;
      this.paginateLoader = false;
      this.orders = data.data.orders;
      this.totalPrice = data.data.totalPrice;
      this.totalPrice2 = data.data.totalPrice2;
      this.totalPrice3 = data.data.totalPrice3;
      this.totalOrders = data.data.totalOrders;
      this.limit = data.data.limit;
    }, () => { });
  }

  private readFileAsDataUrl(file: File): Promise<string> {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = () => resolve(String(reader.result || ''));
      reader.onerror = () => reject();
      reader.readAsDataURL(file);
    });
  }
}
